import React from 'react';

import { Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

import { formatAmount } from './formatAmount';
import { ParsedSlidingScaleRow } from './slidingScaleCsv';

interface Props {
  rows: Array<ParsedSlidingScaleRow>;
  /** How many of them to show, so a long sheet does not fill the dialog. */
  limit: number;
}

/**
 * What the parser made of the sheet, so a mismatched package name is caught
 * here rather than after uploading nothing that resolves.
 */
export default function UploadPreviewTable({ rows, limit }: Props) {
  if (!rows.length) {
    return null;
  }

  const shown = rows.slice(0, limit);

  return (
    <Stack spacing={1}>
      <Typography variant="body2" color="text.secondary">
        {rows.length} row(s) ready to upload. Package and package option are matched by name against this service&apos;s
        configurations.
      </Typography>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Season</TableCell>
            <TableCell>Package</TableCell>
            <TableCell>PackageOption</TableCell>
            <TableCell>Currency</TableCell>
            <TableCell align="right">Single supplement</TableCell>
            <TableCell align="right">Pax quoted</TableCell>
            <TableCell>CSV row</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {shown.map(({ item, rowNumber }) => (
            <TableRow key={rowNumber}>
              <TableCell>{item.season}</TableCell>
              <TableCell>{item.tourConfiguration}</TableCell>
              <TableCell>{item.packageConfiguration}</TableCell>
              <TableCell>{item.currency}</TableCell>
              <TableCell align="right">{formatAmount(item.singleSupplement)}</TableCell>
              <TableCell align="right">1–{item.scale.length}</TableCell>
              <TableCell>{rowNumber}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {rows.length > shown.length && (
        <Typography variant="body2" color="text.secondary">
          …and {rows.length - shown.length} more row(s) not shown.
        </Typography>
      )}
    </Stack>
  );
}
